const TOOLS = [
  {
    id: 1,
    title: "Milling Estimator",
    location: "United States",
    remote: true,
    paymentVerified: true,
    hourlyUSD: 8,
    postedTime: "50 minutes ago",
    description: `https://miro.medium.com/max/1024/1*p37lySM9ixBitfIs0aRSuA.png.`,
    category: "Milling Estimator",
    instructions: "Lorem ipsom yo mamma gipsum"
  },
  {
    id: 2,
    title: "Tack Estimator",
    location: "WorldWide",
    remote: true,
    paymentVerified: true,
    hourlyUSD: 9,
    postedTime: "4 days ago",
    description: `https://miro.medium.com/max/1024/1*p37lySM9ixBitfIs0aRSuA.png`,
    category: "Tack Estimator",
    instructions: "Lorem ipsom yo mamma gipsum"
  },
  {
    id: 3,
    title: "Milling Data Tables",
    location: "United States",
    remote: true,
    paymentVerified: true,
    hourlyUSD: 8,
    postedTime: "Yesterday",
    description: `https://miro.medium.com/max/1024/1*p37lySM9ixBitfIs0aRSuA.png`,
    category: "Milling Data Table",
    instructions: "Lorem ipsom yo mamma gipsum"
  },
  {
    id: 4,
    title: "Tack Data Table",
    location: "United States",
    remote: true,
    paymentVerified: true,
    hourlyUSD: 8,
    postedTime: "Yesterday",
    description: `https://miro.medium.com/max/1024/1*p37lySM9ixBitfIs0aRSuA.png`,
    category: " Tack Data Table",
    instructions: "Lorem ipsom yo mamma gipsum"
  }
];

export default TOOLS;
